export const TAB_SIZE = "980px";
export const DRAWER_WIDTH = "270px";
export const DRAWER_WIDTH_NUMBER = 270;
export const CLOSE_SIDEBAR_ON = "xl";
export const TABLE_MIN_WIDTH_ON_MOBILE = 200;
export const TABLE_MIN_WIDTH_BREAKPOINT = 768;
export const APP_NAME = "Story Tree";
export const GENERAL_API_ERROR =
  "Something went wrong. Please try again later.";
export const DATA_KEY = "data";
export const META_DATA_KEY = "metadata";
export const GENERAL_FORMAT_DATE_ONLY = "MM/DD/YYYY";
export const GENERAL_FORMAT_DATE = "MMM DD, YYYY";

export const PERSIST_STORE = "PERSIST_STORE";

export const TRANSACTION_ENUMS_MODIFIED = {
  Pending: "Pending",
  Completed: "Approved",
  Rejected: "Rejected",
};
